module.exports = __webpack_public_path__ + "img/vue.c5439280.png";